import Swiper from 'swiper';
import { A11y, Navigation, Thumbs, Pagination, Scrollbar } from 'swiper/modules';

export default Swiper;
export const a11y = A11y;
export const navigation = Navigation;
export const thumbs = Thumbs;
export const pagination = Pagination;
export const scrollbar = Scrollbar;